export default "__VITE_ASSET__DWoP_8S7__"